import React from 'react'
import api from 'configs/api'
import { formatUTC } from 'utils/date'
import { alertDanger } from 'utils/toast'
import { translate } from 'locales'

export const savePrescription = async (
  data: any,
  user_id: string,
  scheduling_id: string
) => {
  try {
    await api.post('/doctors/ms/v1/prescription', {
      schedule_id: scheduling_id,
      user_id: user_id,
      patient_url: data.UrlPacientes,
      validation_code: data.CodigoValidacao,
      documents: data.Documentos,
      full_payload: data,
    })
  } catch (err) {
    console.error(err)
  }
}

export const findAllMedicalRecords = async (
  userUUID: string,
  setRecord: React.Dispatch<React.SetStateAction<any>>,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  page: number,
  setTotalPages: any
) => {
  setLoading(true)
  try {
    const find = await api.get(
      `/doctors/v2/medical-record/user/${userUUID}?page=${page}&limit=6`
    )
    const { medicalRecords, patient, totalPages } = find.data
    setTotalPages(totalPages)

    const result = medicalRecords.reduce((res: any, i: any) => {
      res[formatUTC(i.created_at, 'yyyy/MM/dd')] =
        res[formatUTC(i.created_at, 'yyyy/MM/dd')] || []

      res[formatUTC(i.created_at, 'yyyy/MM/dd')].push(i)

      return res
    }, {})

    setRecord({
      user: patient,
      address: patient?.address,
      cellphones: [patient?.personal_data?.cellphone],
      medicalRecords: result,
    })
    setLoading(false)
  } catch (err: any) {
    setLoading(false)
    alertDanger(
      err?.response?.data?.data?.errors[0]?.msg ||
        translate('errors.internalError')
    )
  }
}

export const findAllMedicalRecordsPsico = async (
  userUUID: string,
  areaUUID: any,
  setRecord: React.Dispatch<React.SetStateAction<any>>,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>,
  page?: number,
  setTotalPages?: any
) => {
  try {
    setLoading(true)
    const find = await api.get(
      `/doctors/v2/medical-record/user/${userUUID}/psico/${areaUUID}?page=${page}&limit=10`
    )

    const { patient, medicalRecords, totalPages } = find.data
    setTotalPages(totalPages)
    const resultPsico = medicalRecords.reduce((res: any, i: any) => {
      res[formatUTC(i.created_at, 'yyyy/MM/dd')] =
        res[formatUTC(i.created_at, 'yyyy/MM/dd')] || []

      res[formatUTC(i.created_at, 'yyyy/MM/dd')].push(i)

      return res
    }, {})

    setRecord({
      user: patient,
      medicalRecordsPsico: resultPsico,
    })
    setLoading(false)
  } catch (err: any) {
    setLoading(false)
    alertDanger(
      err?.response?.data?.data?.errors[0]?.msg ||
        translate('errors.internalError')
    )
  }
}
export const findAllMedicalRecordsFollowUp = async (
  userUUID: string,
  setRecord: React.Dispatch<React.SetStateAction<any>>,
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
) => {
  try {
    const find = await api.get(`nursing/accompaniment/doctor/user/${userUUID}`)

    const datas = find.data

    const resultFollowUp = datas.reduce((res: any, i: any) => {
      res[formatUTC(i.date_accompaniment, 'yyyy/MM/dd')] =
        res[formatUTC(i.date_accompaniment, 'yyyy/MM/dd')] || []

      res[formatUTC(i.date_accompaniment, 'yyyy/MM/dd')].push(i)

      return res
    }, {})

    setRecord({
      medicalRecordsFollowUp: resultFollowUp,
    })
    setLoading(false)
  } catch (err: any) {
    setLoading(false)
    alertDanger(
      err?.response?.data?.data?.errors[0]?.msg ||
        translate('errors.internalError')
    )
  }
}
